import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconChevronDoubleDown';
/** Renders an SVG icon. */
const SvgChevronDoubleDown = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M22.204 16.204a1.126 1.126 0 0 1 1.592 1.592l-7 7c-.44.44-1.153.44-1.592 0l-7-7a1.126 1.126 0 0 1 1.592-1.592L16 22.408z"
      />
      <path
        fill="currentColor"
        d="M22.204 8.204a1.126 1.126 0 0 1 1.592 1.592l-7 7c-.44.44-1.153.44-1.592 0l-7-7a1.126 1.126 0 0 1 1.592-1.592L16 14.408z"
      />
    </svg>
  );
};
SvgChevronDoubleDown.displayName = displayName;
export default SvgChevronDoubleDown;
